<!--
 * @Description: 单票下单
 * @Author: ganjia
 * @Date: 2019-10-15 14:10:50
 -->
<template>
  <div class="main-wrap singleOrder">
      <el-form class="el-form-edit" ref="sizeForm" :rules="rules" :inline="true" :model="formData" label-position="left" label-suffix=":" label-width="180px">
        <el-row :gutter="24">
            <el-col :span="12">
                <h3>{{$lang('寄件人信息')}}</h3>
                <div class="group-content">
                <el-form-item :label="$lang('姓名')" prop="senderName">
                    <el-autocomplete
                        valueKey="name"
                        v-model="formData.senderName"
                        @select="changeSenderName"
                        :fetch-suggestions="remoteSenderName"
                        :maxlength="60"
                        :placeholder="$lang('请输入寄件人姓名')">
                        <template slot="suffix">
                            <i class="iconfont icondizhibao pointer" @click="open(1)"></i>
                        </template>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item class="area-code" label-width="100px" :label="$lang('区号')">
                  <el-button plain style="width:100px;">+52</el-button>
                </el-form-item>
                <el-form-item :label="$lang('联系电话')" prop="senderMobilePhone">
                   <template slot="label"><span :title="$lang('联系电话')">{{$lang('联系电话')}}</span></template>
                    <el-autocomplete
                        :maxlength="10"
                        valueKey="mobile"
                        @select="changeSenderName"
                        v-model="formData.senderMobilePhone"
                        :fetch-suggestions="remoteSenderMobilePhone"
                        :placeholder="$lang('请输入寄件人联系电话')">
                    </el-autocomplete>
                </el-form-item>
                <el-form-item :label="$lang('公司名称')" prop="senderCompany">
                    <template slot="label"><span :title="$lang('公司名称')">{{$lang('公司名称')}}</span></template>
                    <el-input v-model="formData.senderCompany" :placeholder="$lang('请输入公司名称')"  :minlength="1"  :maxlength="256" />
                </el-form-item>
                <el-form-item :label="$lang('邮箱')" id="areaCodeSty" prop="senderEmail">
                   <el-input v-model.trim="formData.senderEmail" :minlength="1"  :maxlength="30"></el-input>
                </el-form-item>
                <el-form-item :label="$lang('邮编')" id="areaCodeSty" prop="senderPostalCode">
                   <el-input v-model.trim="formData.senderPostalCode" :minlength="1" :maxlength="5" @input='postalCodeOnInput(formData.senderPostalCode, 1, "formData")' @blur="postalCodeChange(formData.senderPostalCode, 1, 'formData')"></el-input>
                </el-form-item>
                <!-- <el-form-item :label="$lang('省/市/区')" prop="senderProvince">
                    <BaseAddress ref="senderProvinceSearch" :initAddressData="sendAddressData"
                    :showLevel="3" v-model="formData.senderProvince"> </BaseAddress>
                </el-form-item> -->

                <el-form-item :label="$lang('州')" prop="senderProvinceName">
                  <el-input v-model.trim="formData.senderProvinceName" readonly disabled></el-input>
                  <!-- <el-select v-model="formData.senderProvinceName" @change="dataProvinceChange($event, 1)">
                    <el-option
                      v-for="item in provinceList"
                      :key="item.id"
                      :label="item.nativeName"
                      :value="item.id"
                    />
                  </el-select> -->
                </el-form-item>
                <el-form-item :label="$lang('市')" prop="senderCityName">
                  <el-input v-model.trim="formData.senderCityName" readonly disabled></el-input>
                  <!-- <el-select v-model="formData.senderCityName" @change="dataCityChange($event, 1)">
                    <el-option
                      v-for="item in cityList"
                      :key="item.id"
                      :label="item.nativeName"
                      :value="item.id"
                    />
                  </el-select> -->
                </el-form-item>
                <el-form-item :label="$lang('乡镇')" prop="senderAreaName">
                  <el-select v-model="formData.senderAreaName" @change="dataAreaChange($event, 1)">
                    <el-option
                      v-for="item in areaList"
                      :key="item.id"
                      :label="item.nativeName"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>

                <el-form-item class="el-form-item w360 el-form-item--small" :label="$lang('详细地址1')" prop="senderDetailedAddress">
                    <el-input v-model="formData.senderDetailedAddress" :placeholder="$lang('请填写寄件人所在街道以及详细地址')" :minlength="1"  :maxlength="256" ></el-input>
                    <!-- <el-checkbox v-model="checkSenderFlag" style="margin-left:15px">{{$lang('保存至地址簿')}}</el-checkbox> -->
                </el-form-item>
                <el-form-item class="el-form-item w360 el-form-item--small" :label="$lang('详细地址2')" prop="senderAlternateAddress">
                    <el-input v-model="formData.senderAlternateAddress" :placeholder="$lang('请填写寄件人所在街道以及详细地址')" :minlength="1"  :maxlength="256" ></el-input>
                    <el-checkbox v-model="checkSenderFlag" style="margin-left:15px">{{$lang('保存至地址簿')}}</el-checkbox>
                </el-form-item>
                </div>
            </el-col>
            <el-col :span="12">
                <h3>{{$lang('收件人信息')}}</h3>
                <div class="group-content">

                <el-form-item :label="$lang('姓名')" prop="receiverName">
                    <!-- <el-input v-model="formData.receiverName" :placeholder="$lang('请输入收件人姓名')"   :minlength="1"  :maxlength="12" > -->
                        <el-autocomplete
                        valueKey="name"
                        v-model="formData.receiverName"
                        @select="changeReceiverName"
                        :fetch-suggestions="remoteReceiverName"
                        :maxlength="60"
                        :placeholder="$lang('请输入收件人姓名')">
                    <template slot="suffix">
                        <i class="iconfont icondizhibao pointer" @click="open(2)"></i>
                    </template>
                    </el-autocomplete>
                    <!-- </el-input> -->
                </el-form-item>
                <el-form-item class="area-code" label-width="100px" :label="$lang('区号')">
                  <el-button plain style="width:100px;">+52</el-button>
                </el-form-item>
                <el-form-item :label="$lang('联系电话')"  prop="receiverMobilePhone">
                     <template slot="label"><span :title="$lang('联系电话')">{{$lang('联系电话')}}</span></template>
                    <!-- <el-input v-model="formData.receiverMobilePhone" :maxlength='15'  :placeholder="$lang('请输入收件人联系电话')"></el-input> -->
                      <el-autocomplete
                        valueKey="mobile"
                        :maxlength="10"
                        @select="changeReceiverName"
                        v-model="formData.receiverMobilePhone"
                        :fetch-suggestions="remoteReceiverMobilePhone"
                        :placeholder="$lang('请输入收件人联系电话')">
                    </el-autocomplete>
                </el-form-item>
                <el-form-item :label="$lang('公司名称')" prop="receiverCompany">
                     <template slot="label"><span :title="$lang('公司名称')">{{$lang('公司名称')}}</span></template>
                    <el-input v-model="formData.receiverCompany" :placeholder="$lang('请输入公司名称')"  :minlength="1"  :maxlength="256" />
                </el-form-item>
                <el-form-item :label="$lang('邮箱')" id="areaCodeSty" prop="receiverEmail">
                   <el-input v-model.trim="formData.receiverEmail" :minlength="1"  :maxlength="30"></el-input>
                </el-form-item>
                <el-form-item :label="$lang('邮编')" id="areaCodeSty" prop="receiverPostalCode">
                   <el-input v-model.trim="formData.receiverPostalCode" :minlength="1" :maxlength="5" @input='postalCodeOnInput(formData.receiverPostalCode, 2, "formData")'  @blur="postalCodeChange(formData.receiverPostalCode, 2, 'formData')"></el-input>
                </el-form-item>
                <!-- <el-form-item :label="$lang('省/市/区')" prop="receiverProvince">
                    <BaseAddress ref="receiverProvinceSearch" :initAddressData="receiverAddressData" :showLevel="3" v-model="formData.receiverProvince"> </BaseAddress>
                </el-form-item> -->
                <el-form-item :label="$lang('州')" prop="receiverProvinceName">
                  <el-input v-model.trim="formData.receiverProvinceName" readonly disabled></el-input>
                  <!-- <el-select v-model="formData.receiverProvinceName" @change="dataProvinceChange($event, 2)">
                    <el-option
                      v-for="item in provinceList"
                      :key="item.id"
                      :label="item.nativeName"
                      :value="item.id"
                    />
                  </el-select> -->
                </el-form-item>
                <el-form-item :label="$lang('市')" prop="receiverCityName">
                  <el-input v-model.trim="formData.receiverCityName" readonly disabled></el-input>
                  <!-- <el-select v-model="formData.receiverCityName" @change="dataCityChange($event, 2)">
                    <el-option
                      v-for="item in cityList2"
                      :key="item.id"
                      :label="item.nativeName"
                      :value="item.id"
                    />
                  </el-select> -->
                </el-form-item>
                <el-form-item :label="$lang('乡镇')" prop="receiverAreaName">
                  <el-select v-model="formData.receiverAreaName" @change="dataAreaChange($event, 2)">
                    <el-option
                      v-for="item in areaList2"
                      :key="item.id"
                      :label="item.nativeName"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item class="el-form-item el-form-item--small w360" :label="$lang('详细地址1')" prop="receiverDetailedAddress">
                    <el-input v-model="formData.receiverDetailedAddress" :placeholder="$lang('请填写收件人所在街道以及详细地址')"  :minlength="1"  :maxlength="256"></el-input>
                    <!-- <el-checkbox v-model="checkReceiverFlag" style="margin-left:15px">{{$lang('保存至地址簿')}}</el-checkbox> -->
                </el-form-item>
                <el-form-item class="el-form-item el-form-item--small w360" :label="$lang('详细地址2')" prop="receiverAlternateAddress">
                    <el-input v-model="formData.receiverAlternateAddress" :placeholder="$lang('请填写收件人所在街道以及详细地址')"  :minlength="1"  :maxlength="256"></el-input>
                    <el-checkbox v-model="checkReceiverFlag" style="margin-left:15px">{{$lang('保存至地址簿')}}</el-checkbox>
                </el-form-item>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                    <h3>{{$lang('货物信息')}}</h3>
                         <div class="group-content">
                            <el-form-item :label="$lang('物品类型')" prop="goods" ref="goods">
                                <Base-Select v-model="formData.goods" :props="{label:'name',value:'code', res:'appArticleTypeVOList',valueObj:true}"
                                    dicUrl="/vip/baseData/list"  :placeholder="$lang('请选择')">
                                </Base-Select>
                            </el-form-item>
                            <el-form-item :label="$lang('物品名称')" prop="goodsName">
                            <el-input v-model="formData.goodsName" :placeholder="$lang('请输入')" :minlength="1"  :maxlength="20"></el-input>
                            </el-form-item>
                            <el-form-item :label="$lang('物品件数')" prop="packageNumber">
                            <el-input v-model="formData.packageNumber" :placeholder="$lang('请输入')" :minlength="1"  :maxlength="3"></el-input>
                            </el-form-item>
                            <el-form-item :label="$lang('净重(kg)')" prop="netWeight">
                              <el-input-number v-model="formData.netWeight" :label="$lang('描述文字')" :precision="2"  :min="0" :max="30"></el-input-number>
                            </el-form-item>
                            <el-form-item :label="$lang('包裹重(kg)')" prop="packageTotalWeight">
                            <el-input-number v-model="formData.packageTotalWeight" :label="$lang('描述文字')" :precision="2"  :min="0" :max="30"></el-input-number>
                            </el-form-item>
                            <el-form-item :label="$lang('结算方式')" prop="payment">
                                <Base-Select v-model="formData.payment" :props="{label:'name',value:'code', res:'appPaymentMannerVOList',valueObj:true}"
                                    dicUrl="/vip/baseData/list"  :placeholder="$lang('请选择')">
                                </Base-Select>
                                <!-- <Base-Select v-model="formData.payment" :dic="payTypesDic" :placeholder="$lang('请选择')"  :props="{label:'name' ,value:'code',valueObj:true}"></Base-Select> -->
                            </el-form-item>

                            <!-- 0510新增快递类型 -->
                             <el-form-item :label="$lang('快递类型')" prop="expressType">
                                <Base-Select v-model="formData.expressType" :props="{label:'name',value:'code', res:'appProductTypeVOList',valueObj:true}"
                                    dicUrl="/vip/baseData/list"  :placeholder="$lang('请选择')" @getDic="getDic">
                                </Base-Select>
                            </el-form-item>

                            <el-form-item :label="$lang('参考运费')" prop="standardValue" v-if="this.userInfo.freightStatus === 1">
                            <el-input v-model="formData.standardValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
                            </el-form-item>
                            <!-- <el-form-item :label="$lang('箱材规格')" prop="boxStandard">
                                <Base-Select v-model="formData.boxStandard"
                                    :props="{label:'name',value:'id', res:'records',valueObj:true}"
                                    dicUrl="/vip/material/getMaterialSalesPrice"
                                    :placeholder="$lang('请选择')">
                                </Base-Select>
                            </el-form-item> -->
                            <!-- <el-form-item :label="$lang('箱材数量')" prop="boxNumber">
                                 <el-input-number v-model="formData.boxNumber" label="描述文字" :step="1" :precision="0" :min="0" :max="99"></el-input-number>
                            </el-form-item> -->
                            <!-- <el-form-item :label="$lang('箱材单价')" prop="boxPrice">
                                 <el-input v-model="formData.boxPrice" :placeholder="$lang('请输入')" :disabled="true"></el-input>
                            </el-form-item> -->
                            <el-form-item :label="$lang('客户订单号')" prop="customerOrderId">
                                <template slot="label"> <span :title="$lang('客户订单号')">{{$lang('客户订单号')}}</span></template>
                            <el-input
                                v-model="formData.customerOrderId"
                                :placeholder="isCustomerLabelDisabled ? $lang('') : $lang('请输入')"
                                :minlength="1"
                                :maxlength="50"
                                :disabled="isCustomerLabelDisabled"
                            ></el-input>
                            </el-form-item>
                           <el-form-item :label="$lang('是否保价')" prop="insured" class="insured-info">
                             <!-- <Base-Select :clearable="false" v-model="formData.insured" :dic="insuredDic" :disabled="formData.goodsTypeName === '文件' || formData.paymentModeName === 'PP_PM' " :placeholder="$lang('请选择')"  @change="changeInsured" :props="{label:'name' ,value:'code'}"></Base-Select> -->
                             <Base-Select :clearable="false" v-model="formData.insured" :dic="insuredDic" :placeholder="$lang('请选择')"  @change="changeInsured" :props="{label:'name' ,value:'code'}" :disabled="paymentOption"></Base-Select>
                             <div class="btn-insured-wrapper">
                               <a class="btn_insured_myself" @click="openInsured">{{$lang('保价声明')}}</a>
                             </div>
                           </el-form-item>
                            <el-form-item :label="$lang('物品价值')" prop="declaredValue" v-show="formData.insured === 1" class="declaredValue">
                              <el-input-number v-model="formData.declaredValue" :placeholder="$lang('请输入')" :step="1" :precision="2" :controls="false" :min="0" :max="100000"></el-input-number>
                            </el-form-item>
                            <el-form-item :label="$lang('保价费')" prop="insuredValue" v-show="formData.insured===1">
                            <el-input v-model="formData.insuredValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
                            </el-form-item>
                            <!-- 是否签回单 -->
                             <el-form-item :label="$lang('是否签回单')" prop="signReceipt">
                                <template slot="label"> <span :title="$lang('是否签回单')">{{$lang('是否签回单')}}</span></template>
                                <Base-Select :clearable="false"
                                 v-model="formData.signReceipt"
                                 :dic="signReceiptDic"
                                 :disabled="true"
                                 :placeholder="$lang('请选择')"
                                 @change="changeSignReceipt"
                                 :props="{label:'name' ,value:'code'}">
                                 </Base-Select>
                            </el-form-item>
                            <el-form-item :label="$lang('回单管理费')" prop="receiptFreight" v-show="formData.signReceipt===1">
                                <el-input v-model="formData.receiptFreight" :disabled="true"></el-input>
                            </el-form-item>
                            <el-form-item :label="$lang('燃油附加费')" prop="fuelCost" class="declaredValue" v-if="this.userInfo.freightStatus === 1">
                              <el-input-number v-model="formData.fuelCost" :disabled="true" :placeholder="$lang('请输入')" :step="1" :precision="3" :controls="false" :min="0" :max="100000"></el-input-number>
                            </el-form-item>
                            <el-form-item :label="$lang('增值税')" prop="fuelVat" class="declaredValue" v-if="this.userInfo.freightStatus === 1">
                              <el-input-number v-model="formData.fuelVat" :disabled="true" :placeholder="$lang('请输入')" :step="1" :precision="3" :controls="false" :min="0" :max="100000"></el-input-number>
                            </el-form-item>
                            <el-form-item :label="$lang('总运费')" prop="totalFreight" class="declaredValue" v-if="this.userInfo.freightStatus === 1">
                              <el-input-number v-model="formData.totalFreight" :disabled="true" :placeholder="$lang('请输入')" :step="1" :precision="3" :controls="false" :min="0" :max="100000"></el-input-number>
                            </el-form-item>
                            <!-- <el-form-item :label="$lang('下单数量')" >
                                <el-input-number v-model="formData" :min="1" :max="99"></el-input-number>
                            </el-form-item> -->
                            <br>
                                  <el-form-item :label="$lang('备注')" prop="remarks" class="el-form-item el-form-item--small" style="width:50%">
                                         <el-input v-model="formData.remarks" :placeholder="$lang('请输入')" type="textarea" :rows="4" show-word-limit :maxlength="256" resize="none" ></el-input>
                                 </el-form-item>
                         </div>
            </el-col>
        </el-row>

      </el-form>
      <div class="bc-bottom">
        <el-button type="primary" @click="saveSubmit('sizeForm')" :loading="keyBtn" class="enter_btn">{{ $lang('立即下单') }}</el-button>
      </div>
    <!-- </div> -->
    <SmartSpot v-model="smartSpot"></SmartSpot>
    <AddressBook v-model="addrBook" pageType="singleOrder" :selectType="selectType" @single-row-select="singleRowSelect" ref='address'></AddressBook>
    <InsuredStatement :infoVisible="infoVisible" @closeInsured="closeInsured"></InsuredStatement>
    <super-zone :dialogVisible.sync="superVisible"></super-zone>
  </div>
</template>
<script>
import { RESPONSE_SUCCESS } from '@constants'
import { RULES, phoneAndMobile, integerWeight, checkGoodsName } from '@utils/rules'

// import { RULES, phoneAndMobile, checkAddressFormat, integerWeight, checkGoodsName, isNull } from '@utils/rules'

import { DIC } from '@constants'
import SmartSpot from './SmartSpot'
import AddressBook from './AddressBook'
import { vipOrderAdd, reqAddressList, getComCost, getSettlement, getComputationCost, getDefaultAddress, printOrders, getReceiptFee, queryAddressAnalysisAddress, getfuelCost } from '@api/module/customer'
import InsuredStatement from '@components/dialog/InsuredStatement'
import address from '@/mixins/address'
import { mapActions } from 'vuex'
import superZone from '../../../components/dialog/superZone.vue'

export default {
  name: 'SingleOrder',
  mixins: [address],
  components: {
    SmartSpot,
    AddressBook,
    InsuredStatement,
    superZone
  },
  data() {
    return {
      DIC,
      COM_HTTP: {
        reqAdd: vipOrderAdd
      },
      showClick: false,
      printOptions: {
        btnTitle: '下单并打印',
        btnType: 'primary',
        isHideIcon: true
      },
      paymentOption: false,
      printOrder: false,
      keyBtn: false,
      keyBtn1: false,
      getOrderId: '', // 获取下单并打印的订单id
      rules: {
        senderName: [RULES.required, RULES.senderName],
        senderMobilePhone: [RULES.required, { validator: phoneAndMobile }],
        senderProvince: [RULES.requiredSelect],
        senderDetailedAddress: [RULES.required, RULES.senderCompany],
        senderAlternateAddress: [RULES.senderCompany],
        receiverName: [RULES.required, RULES.senderName],
        receiverMobilePhone: [RULES.required, { validator: phoneAndMobile }],
        receiverProvince: [RULES.requiredSelect],
        receiverDetailedAddress: [RULES.required, RULES.senderCompany],
        receiverAlternateAddress: [RULES.senderCompany],
        goods: [RULES.required],
        goodsName: [{ validator: checkGoodsName }],
        packageTotalWeight: [RULES.required, { validator: integerWeight }],
        netWeight: [RULES.required, { validator: integerWeight }],
        packageNumber: [RULES.required, RULES.stopSellTime],
        payment: [RULES.requiredSelect],
        insured: [RULES.requiredSelect],
        expressType: [RULES.requiredSelect],
        senderCompany: [RULES.senderCompany],
        receiverCompany: [RULES.senderCompany],
        senderEmail: [RULES.email],
        receiverEmail: [RULES.email],
        senderPostalCode: [RULES.required, RULES.postalCode],
        receiverPostalCode: [RULES.required, RULES.postalCode],
        // senderProvinceName: [RULES.requiredSelect],
        // senderCityName: [RULES.requiredSelect],
        senderAreaName: [RULES.requiredSelect],
        // receiverProvinceName: [RULES.requiredSelect],
        // receiverCityName: [RULES.requiredSelect],
        receiverAreaName: [RULES.requiredSelect]
      },
      addrBook: false,
      smartSpot: false,
      infoVisible: false, // 保价费声明弹窗
      defaultFormData: {

      },
      formData: {
        senderName: '', // 寄件人姓名,
        senderMobilePhone: '', // 寄件人手机号,
        senderProvinceId: '', // 寄件省份id,
        senderProvinceName: '', // 寄件省份名称,
        senderCityId: '', // 寄件城市id,
        senderCityName: '', // 寄件城市名称,
        senderAreaId: '', // 寄件区域id,
        senderAreaName: '', // 寄件区域名称,
        senderProvince: '', // 寄件区省/市/区
        senderDetailedAddress: '', // 寄件详细地址,
        senderAlternateAddress: '',
        senderPhoneAreacode: '+52',
        receiverName: '', // 收件人姓名,
        receiverMobilePhone: '', // 收件人手机号,
        receiverProvinceId: '', // 收件省份id,
        receiverProvinceName: '', // 收件省份名称,
        receiverCityId: '', // 收件城市id,
        receiverCityName: '', // 收件城市名称,
        receiverAreaId: '', // 收件区域id,
        receiverAreaName: '', // 收件区域名称,
        receiverProvince: '', // 收件区省/市/区
        receiverDetailedAddress: '', // 收件详细地址,
        receiverAlternateAddress: '',
        receiverPhoneAreacode: '+52',
        insured: 0, // 是否保价1是，0否,
        declaredValue: '', // 物品价值,
        insuredValue: 0, // 保价费,
        goods: '', // 物品类型
        goodsTypeId: '', // 物品类型id,
        goodsTypeCode: '', // 物品类型编码,
        goodsTypeName: '', // 物品类型名称,
        goodsName: '', // 物品名称,
        packageTotalWeight: 1, // 包裹重,
        netWeight: 1,
        packageNumber: 1, // 物品件数,
        payment: { code: 'PP_PM', name: this.$lang('PP_PM'), id: 7, type: 'ZD106' }, // 支付方式
        paidModeId: 7, // 支付方式id,
        paidModeCode: 'PP_PM', // 支付方式编码,
        paidModeName: this.$lang('PP_PM'), // 支付方式名称,
        paymentModeId: 7, // 支付方式id,
        paymentModeCode: 'PP_PM', // 支付方式编码,
        paymentModeName: this.$lang('PP_PM'), // 支付方式名称,
        senderStreet: 'dasd',
        expressType: '', // 快递类型
        expressTypeCode: '', // 快递类型code
        expressTypeName: '', // 快递类型name
        codMoney: '', // COD,
        codFee: 0, // COD手续费,
        standardValue: 0, // 参考运费,
        boxNumber: 0, // 箱材数量,
        boxStandard: '', // 箱材规格
        boxStandardId: '', // 箱材规格id,
        boxStandardCode: '', // 箱材规格编码,
        boxStandardName: '', // 箱材规格名称,
        boxPrice: 0, // 箱材单价,
        boxTotalPrice: 0, // 箱材总价,
        remarks: '', // 备注,
        settlementWeight: 0, // 结算重量
        packageChargeWeight: 1, // 结算重量
        customerOrderId: '',
        senderCompany: '',
        senderPostalCode: '',
        senderEmail: '',
        receiverEmail: '',
        receiverPostalCode: '',
        receiverCompany: '',
        checkSenderFlag: '', // 寄件人保存至地址簿
        checkReceiverFlag: '', // 寄件人保存至地址簿
        signReceipt: 0, // 签回单 0否 1是
        receiptFreight: 0, // 回单金额
        fuelCost: 0, // 燃油附加费
        fuelVat: 0, // 增值税
        totalFreight: 0 // 总运费
      },
      fuelSurcharge: 0, // 燃油附加费费率
      vatChange: 0, // 增值税费率
      receiptFreight: 0,
      checkSenderFlag: false,
      checkReceiverFlag: false,
      initData: {
        url: '/oauth/sysRoleResource/getAppResources',
        type: 'app',
        leftText: this.$lang('未选权限'),
        rightText: this.$lang('已选权限'),
        rightOptText: this.$lang('全部权限'),
        exculdeIdsParam: 'resourceIds'
      },
      selectType: 1,
      sendAddressData: {
        formProps: {
          provinceIdProp: 'senderProvinceId',
          provinceNameProp: 'senderProvinceName',
          cityIdProp: 'senderCityId',
          cityNameProp: 'senderCityName',
          areaIdProp: 'senderAreaId',
          areaNameProp: 'senderAreaName'
        },
        defaultData: {}
      },
      receiverAddressData: {
        formProps: {
          provinceIdProp: 'receiverProvinceId',
          provinceNameProp: 'receiverProvinceName',
          cityIdProp: 'receiverCityId',
          cityNameProp: 'receiverCityName',
          areaIdProp: 'receiverAreaId',
          areaNameProp: 'receiverAreaName'
        },
        defaultData: {}
      },
      insuredDic: [{ code: 0, label: this.$lang('否'), name: this.$lang('否') }, { code: 1, label: this.$lang('是'), name: this.$lang('是') }],
      signReceiptDic: [{ code: 0, label: this.$lang('否'), name: this.$lang('否') }, { code: 1, label: this.$lang('是'), name: this.$lang('是') }],
      // payTypesDic: [{ code: 'PP_PM', name: this.$lang('寄付月结'), id: 319, type: 'ZD106' }, { code: 'PP_CASH', name: this.$lang('寄付现结'), id: 320, type: 'ZD106' }, { code: 'CC_CASH', name: this.$lang('到付现结'), id: 321, type: 'ZD106' }],
      superVisible: false
    }
  },

  created() {
    this.fromType = this.comeFrom
    if (this.id) {
      this.getDetail()
    }
    if (this.formData.insured === 1) { // 是否保价1是，0否,
      this.rules.declaredValue = [RULES.required, RULES.declaredValue]
    }
    this.getReceiptFee() // 获取回单金额
  },
  computed: {
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
    isCustomerLabelDisabled() {
      // 客户标识customerLabel是否为1，为1则自动生成订单号不允许手工修改，反之可手工修改
      return this.userInfo.customerLabel === '1'
    }
  },
  watch: {
    // 物品类型
    async 'formData.goods'(val) {
      const { id: goodsTypeId, code: goodsTypeCode, name: goodsTypeName } = val
      Object.assign(this.formData, { goodsTypeId, goodsTypeCode, goodsTypeName })
      const { declaredValue, goods, insured } = this.formData
      if (insured === 1 && goods && parseFloat(declaredValue) > 0) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
      }
      if (goodsTypeName === '文件') {
        Object.assign(this.formData, { insured: 0, declaredValue: '' })
        this.formData.insuredValue = 0
      }
      this.calcStandardCostBefore()
    },
    // 支付方式
    async 'formData.payment'(val) {
      const { id: paymentModeId, code: paymentModeCode, name: paymentModeName } = val
      if (val.code === 'CC_CASH') {
        this.paymentOption = true
        Object.assign(this.formData, { insured: 0, declaredValue: '' })
      } else {
        this.paymentOption = false
        // this.formData.declaredValue = ''
      }
      Object.assign(this.formData, { paymentModeId, paymentModeCode, paymentModeName })
      // 运费查询
      this.calcStandardCostBefore()
      // 到付现结不支持保价
      if (val.name === '到付现结') {
        Object.assign(this.formData, { insured: 0, declaredValue: '', signReceipt: 0 })
        this.formData.insuredValue = 0
        this.formData.receiptFreight = 0
      }
      console.log(this.formData)
    },
    async 'formData.expressType'(val) {
      console.log(val)
      const { code, name } = val
      Object.assign(this.formData, { expressTypeCode: code, expressTypeName: name })
      this.calcStandardCostBefore()
    },
    // 运费计算
    async 'formData.senderAreaId'(val) {
      console.log('运费计算senderAreaId-------------', val, this.formData)
      this.calcStandardCostBefore()
      // const { receiverProvinceId, packageTotalWeight } = this.formData
      // if (receiverProvinceId && val && packageTotalWeight > 0) {
      //   const res = await this.calcStandardCost(this.formData)
      //   Object.assign(this.formData, res)
      // }
    },
    // 运费计算
    async 'formData.receiverAreaId'(val) {
      console.log('运费计算receiverAreaId-------------', val, this.formData)
      // const { senderProvinceId, packageTotalWeight } = this.formData
      // if (senderProvinceId && val && packageTotalWeight > 0) {
      //   const res = await this.calcStandardCost(this.formData)
      //   Object.assign(this.formData, res)
      // }
      this.calcStandardCostBefore()
    },
    // 运费重量
    async 'formData.packageTotalWeight'(val) {
      console.log('运费计算-------------', val, this.formData)
      this.calcStandardCostBefore()
      // const { senderProvinceId, receiverProvinceId } = this.formData
      // if (senderProvinceId && receiverProvinceId && val > 0) {
      //   const res = await this.calcStandardCost(this.formData)
      //   Object.assign(this.formData, res)
      // }
    },
    // 箱材规格计算
    async 'formData.boxStandard'(val) {
      const { id: boxStandardId, name: boxStandardName, salesPrice: boxPrice } = val
      const res = await this.calcBoxStandard({ boxStandardId, boxStandardName, boxPrice })
      Object.assign(this.formData, res, {
        // 箱材规格id
        boxStandardId,
        // 箱材规格名称
        boxStandardName,
        // 箱材单价
        boxPrice
      })
    },
    // 箱材数量
    async 'formData.boxNumber'(val) {
      const { boxStandardId, boxStandardName, boxPrice } = this.formData
      const res = await this.calcBoxStandard({ boxStandardId, boxStandardName, boxPrice })
      Object.assign(this.formData, res)
    },
    // 保价费计算
    async 'formData.declaredValue'(val) {
      const { goods, insured } = this.formData
      if (insured === 1 && goods && parseFloat(val) > 0) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
      }
    },

    async 'formData.standardValue' (val) {
      console.log(val)
      const { standardValue, insuredValue } = this.formData
      try {
        const { code, msg, data } = await getfuelCost()
        if (data && (data.fuelSurcharge || data.vat)) {
          this.fuelSurcharge = data.fuelSurcharge ? parseFloat(data.fuelSurcharge) : 0
          this.vatChange = data.vat ? parseFloat(data.vat) : 0
          console.log(code + msg + data)
          this.formData.fuelCost = this.checkCost(parseFloat(standardValue), parseFloat(insuredValue), this.fuelSurcharge, -1)
          this.formData.fuelVat = this.checkCost(parseFloat(standardValue), parseFloat(insuredValue), this.vatChange, parseFloat(this.formData.fuelCost))
        } else {
          Object.assign(this.formData, { fuelCost: 0, fuelVat: 0 })
        }
        this.$nextTick(_ => {
          this.formData.totalFreight = parseFloat(standardValue) + this.formData.fuelCost + this.formData.fuelVat
        })
      } catch (error) {
        // this.keyBtn1 = false
      }
    },

    async 'formData.insuredValue' (val) {
      console.log(val)
      const { standardValue, insuredValue } = this.formData
      try {
        const { code, msg, data } = await getfuelCost()
        if (data && (data.fuelSurcharge || data.vat)) {
          this.fuelSurcharge = data.fuelSurcharge ? parseFloat(data.fuelSurcharge) : 0
          this.vatChange = data.vat ? parseFloat(data.vat) : 0
          console.log(code + msg + data)
          this.formData.fuelCost = this.checkCost(parseFloat(standardValue), parseFloat(insuredValue), this.fuelSurcharge, -1)
          this.formData.fuelVat = this.checkCost(parseFloat(standardValue), parseFloat(insuredValue), this.vatChange, parseFloat(this.formData.fuelCost))
        } else {
          Object.assign(this.formData, { fuelCost: 0, fuelVat: 0 })
        }
        this.$nextTick(_ => {
          this.formData.totalFreight = parseFloat(standardValue) + this.formData.fuelCost + this.formData.fuelVat
        })
      } catch (error) {
        // this.keyBtn1 = false
      }
    }
  },

  mounted() {
    // 寄件人默认信息
    this.getDefaultAddress({ type: 1 })
    // 收件人默认信息
    this.getDefaultAddress({ type: 2 })
  },
  methods: {
    ...mapActions(['UPDATE_PRINT_STOCK']),
    // 产品类型默认EZ
    getDic(list) {
      const expressTypeItem = list.find(item => item.code === 'EZ')
      if (expressTypeItem) {
        this.formData.expressType = expressTypeItem
      }
    },
    beforePrint() {
      const userInfo = this.userInfo
      if (userInfo.surfaceFormat === 1) {
        this.$alert(this.$lang('请先到我的资料里设置面单格式'), this.$lang('提示'), {
          confirmButtonText: this.$lang('确定')
        })
        return
      } else {
        this.printOrder = true
        this.saveSubmit('sizeForm')
      }
    },
    // 获取打印数据
    async getPrintData(type) {
      const ids = [this.getOrderId]
      const params = { ids: ids, printType: type, isVip: true }
      const { code, msg, data } = await printOrders(params)
      if (code === 1) {
        if (data.length) this.$message.success(this.$lang('已生成打印数据，正在打印中...'))
        this.printOrder = false
        setTimeout(() => {
          // 更新库存面单
          if (this.exportStatus !== 'already_print') {
            this.UPDATE_PRINT_STOCK(true)
          }
        }, 1100)
        return data || []
      } else {
        this.$message.error(this.$lang(msg))
        return []
      }
    },
    // // 获取打印数据
    // async getPrintData(type) {
    //   return [this.formData]
    // },
    discern(type) {
      let text
      switch (type) {
        case 0:
          if (!this.formData.analysisAddress) { return }
          text = this.formData.analysisAddress
          text = text.replace(/\s/g, '')
          queryAddressAnalysisAddress({ text }).then(res => {
            const { code, msg, data } = res
            if (code === RESPONSE_SUCCESS) {
              if (data) {
                const { province, city, county, provinceCode, cityCode, countyCode, detail, phonenum, person } = res.data || {}
                const obj = {
                  senderName: person,
                  senderMobilePhone: phonenum,
                  senderDetailedAddress: detail,
                  senderProvince: {
                    senderProvinceName: province,
                    senderProvinceId: provinceCode,
                    senderCityId: cityCode,
                    senderCityName: city,
                    senderAreaId: countyCode,
                    senderAreaName: county
                  }
                }
                Object.assign(this.formData, obj)
              }
            } else {
              this.$message.error(msg)
            }
          })
          break
        case 1:
          this.formData.analysisAddress = ''
          break
        case 2:
          if (!this.formData.analysisAddress1) { return }
          text = this.formData.analysisAddress1
          text = text.replace(/\s/g, '')
          queryAddressAnalysisAddress({ text }).then(res => {
            const { code, msg, data } = res
            if (code === RESPONSE_SUCCESS) {
              if (data) {
                const { province, city, county, provinceCode, cityCode, countyCode, detail, phonenum, person } = res.data || {}
                const obj = {
                  receiverName: person,
                  receiverMobilePhone: phonenum,
                  receiverDetailedAddress: detail,
                  receiverProvince: {
                    receiverProvinceName: province,
                    receiverProvinceId: provinceCode,
                    receiverCityId: cityCode,
                    receiverCityName: city,
                    receiverAreaId: countyCode,
                    receiverAreaName: county
                  }
                }
                Object.assign(this.formData, obj)
              }
            } else {
              this.$message.error(msg)
            }
          })
          break
        case 3:
          this.formData.analysisAddress1 = ''
          break
        default:
          break
      }
    },
    // 燃油附加费与增值税计算
    checkCost(standardValue, insuredValue, percentage, type) {
      if ((standardValue !== 0 || insuredValue !== 0) && percentage !== 0) {
        if (type === -1) {
          var total1 = Math.round(((Number(standardValue) + Number(insuredValue)) * percentage) * 1000) / 1000
          return total1
        } else {
          var total2 = Math.round(((Number(standardValue) + Number(insuredValue) + Number(type)) * percentage) * 1000) / 1000
          return total2
        }
      } else {
        return 0
      }
    },
    openInsured() {
      this.infoVisible = true
    },
    closeInsured() {
      this.infoVisible = false
    },
    // 运费查询
    async calcStandardCostBefore() {
      const { goodsTypeCode, senderProvinceId, receiverProvinceId, packageTotalWeight, expressTypeCode, paymentModeCode } = this.formData
      if (senderProvinceId && receiverProvinceId && goodsTypeCode && packageTotalWeight > 0 && expressTypeCode && paymentModeCode) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
    },
    // 运费计算
    async calcStandardCost(data) {
      console.log('🚀 ~ calcStandardCost ~ data:', data)
      console.log('🚀 ~ calcStandardCost ~ this.formData:', this.formData)
      const { senderProvinceId, senderCityId, senderAreaId, receiverProvinceId, receiverCityId, receiverAreaId, packageTotalWeight, paymentModeId } = this.formData
      const promises = [
        // 获取起始地址ID
        this.getSettlement(senderProvinceId, senderCityId, senderAreaId),
        // 获取目的地地址ID
        this.getSettlement(receiverProvinceId, receiverCityId, receiverAreaId)
      ]
      const [startAddressId, endAddressId] = await Promise.all(promises)
      // 运费
      const obj = {}
      console.log('startAddressId', startAddressId)
      // 如果起始地址且目的地地址ID存在
      if (startAddressId && endAddressId) {
        // 获取运费
        const res = await this.getComCost(packageTotalWeight, startAddressId, endAddressId, paymentModeId)
        obj.standardValue = res.result
        obj.settlementWeight = res.settValue
      }
      // 返回结果
      return {
        // ...result,
        ...obj
      }
    },

    // 获取默认地址
    async getDefaultAddress(param) {
      const { code, msg, data } = await getDefaultAddress(param)
      if (code === RESPONSE_SUCCESS) {
        if (data) {
          this.singleRowSelect(data, param.type)
        }
        // this.defaultFormData = commonFun.deepClone(this.formData)
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    // 箱材规格计算
    async calcBoxStandard({ boxStandardId, boxStandardName, boxPrice } = {}) {
      const { boxNumber } = this.formData
      // 箱数量
      const boxTotalPrice = this.$common.floatNumSub(boxNumber ? boxNumber * boxPrice : 0)
      return {
        // 箱材总价格
        boxTotalPrice
      }
    },
    // 打开地址
    open(selectType) {
      this.addrBook = true
      this.selectType = selectType
      const data = selectType === 1 ? this.curentSend : this.curentReceiver
      this.$refs.address.updateBtnStauts(data)
      this.$refs.address.initData()
    },
    singleRowSelect(data, type) {
      if (!data.areaId) {
        return
      }
      console.log(data)
      const { name, mobile, detailedAddress, companyName, postalCode, email, detailedAddress2, areaId } = data
      if (type === 1) { // 1寄件2取件
        this.formData.senderName = name // 寄件人姓名,
        this.formData.senderMobilePhone = mobile // 寄件人手机号
        this.formData.senderDetailedAddress = detailedAddress // 寄件详细地址
        this.formData.senderCompany = companyName
        this.formData.senderPostalCode = postalCode
        this.formData.senderEmail = email
        this.formData.senderProvinceId = ''
        this.formData.senderProvinceName = ''
        this.formData.senderCityId = ''
        this.formData.senderCityName = ''
        this.formData.senderAreaId = ''
        this.formData.senderAreaName = ''
        this.formData.senderAlternateAddress = ''
        this.curentSend = data
        // alert(1)
        // this.handleProvice(postalCode, type, areaName, false)
        this.postalCodeChange(this.formData.senderPostalCode, 1, 'formData', true, areaId) // 触发邮编更改方法
      } else if (type === 2) {
        this.formData.receiverName = name // 收件人姓名,
        this.formData.receiverMobilePhone = mobile // 收件人手机号
        this.formData.receiverDetailedAddress = detailedAddress // 收件详细地址
        this.formData.receiverCompany = companyName
        this.formData.receiverPostalCode = postalCode
        this.formData.receiverEmail = email
        this.formData.receiverProvinceId = ''
        this.formData.receiverProvinceName = ''
        this.formData.receiverCityId = ''
        this.formData.receiverCityName = ''
        this.formData.receiverAreaId = ''
        this.formData.receiverAreaName = ''
        this.formData.receiverAlternateAddress = detailedAddress2
        this.curentReceiver = data
        // this.handleProvice(postalCode, type, areaName)
        this.postalCodeChange(this.formData.receiverPostalCode, 2, 'formData', true, areaId) // 触发邮编更改方法
      }
    },
    /**
     * 是否保价
     */
    async changeInsured(val) {
      this.formData.insured = val
      if (val === 0) {
        this.formData.declaredValue = ''
        this.formData.insuredValue = 0
        // this.formData.fuelCost = 0
        // this.formData.fuelVat = 0
        // this.formData.totalFreight = 0
        const { standardValue, insuredValue } = this.formData
        try {
          const { code, msg, data } = await getfuelCost()
          if (data && (data.fuelSurcharge || data.vat)) {
            this.fuelSurcharge = data.fuelSurcharge ? parseFloat(data.fuelSurcharge) : 0
            this.vatChange = data.vat ? parseFloat(data.vat) : 0
            console.log(code + msg + data)
            this.formData.fuelCost = this.checkCost(parseFloat(standardValue), parseFloat(insuredValue), this.fuelSurcharge, -1)
            this.formData.fuelVat = this.checkCost(parseFloat(standardValue), parseFloat(insuredValue), this.vatChange, parseFloat(this.formData.fuelCost))
          } else {
            Object.assign(this.formData, { fuelCost: 0, fuelVat: 0 })
          }
          this.$nextTick(_ => {
            this.formData.totalFreight = parseFloat(standardValue) + this.formData.fuelCost + this.formData.fuelVat
          })
        } catch (error) {
          // this.keyBtn1 = false
        }
      }
    },
    /**
    * 是否签回单
    */
    changeSignReceipt(val) {
      if (val === 0) {
        this.formData.receiptFreight = 0
      } else if (val === 1) {
        this.formData.receiptFreight = this.receiptFreight
      }
    },
    // 收件人姓名或者电话改变
    changeReceiverName(item) {
      const { name, mobile, companyName, detailedAddress, postalCode, detailedAddress2, email, areaId } = item
      this.formData = { ...this.formData, ...{
        receiverName: name || '',
        receiverMobilePhone: mobile || '',
        receiverCompany: companyName || '',
        receiverDetailedAddress: detailedAddress || '',
        receiverPostalCode: postalCode || '',
        receiverAlternateAddress: detailedAddress2 || '',
        receiverEmail: email || '',
        receiverProvinceId: '',
        receiverProvinceName: '',
        receiverCityId: '',
        receiverCityName: '',
        receiverAreaId: '',
        receiverAreaName: ''
      }
      }

      this.postalCodeChange(postalCode, 2, 'formData', true, areaId) // 触发邮编更改方法
      // postalCode && this.handleProvice(postalCode, 2, areaName)
    },
    // 寄件人姓名或者电话改变
    changeSenderName(item) {
      const { name, mobile, companyName, detailedAddress, postalCode, detailedAddress2, email, areaId } = item
      this.formData = { ...this.formData, ...{
        senderName: name || '',
        senderMobilePhone: mobile || '',
        senderCompany: companyName || '',
        senderDetailedAddress: detailedAddress || '',
        senderPostalCode: postalCode || '',
        senderAlternateAddress: detailedAddress2 || '',
        senderEmail: email || '',
        senderProvinceId: '',
        senderProvinceName: '',
        senderCityId: '',
        senderCityName: '',
        senderAreaId: '',
        senderAreaName: ''
      }
      }
      this.postalCodeChange(postalCode, 1, 'formData', true, areaId) // 触发邮编更改方法
      // postalCode && this.handleProvice(postalCode, 1, areaName, false)
    },
    // 表单保存 下单并保存
    // savePrintSubmit(formName) {
    //   console.log('formName',)
    // },
    // 表单保存  立即下单
    async saveSubmit(formName) {
      if (this.formData.paymentModeId === 321 && this.formData.insured !== 0) {
        this.$message.error(this.$lang('到付件不支持保价'))
        return
      }
      if (this.formData.insured === 1 && (!this.formData.declaredValue || parseFloat(this.formData.declaredValue) <= 0)) {
        this.$message.error(this.$lang('物品价值必须大于0'))
        return
      }
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.printOrder) {
            this.keyBtn1 = true
          } else {
            this.keyBtn = true
          }
          if (this.formData.insured === 0) this.formData.declaredValue = ''
          this.formData.packageChargeWeight = this.formData.packageTotalWeight
          this.formData.boxStandardCode = this.formData.boxStandard ? this.formData.boxStandard.code : ''
          this.formData.boxNumber = this.formData.boxStandard ? this.formData.boxNumber : null
          this.formData.checkReceiverFlag = this.checkReceiverFlag ? 1 : 0
          this.formData.checkSenderFlag = this.checkSenderFlag ? 1 : 0
          if (this.userInfo.freightStatus === 0) {
            this.formData.totalFreight = parseFloat(this.formData.totalFreight).toFixed(2)
          }
          this.vipOrderAdd(this.formData)
        } else {
          return false
        }
      })
    },
    async vipOrderAdd(reqData) { // 新增订单
      try {
        const resData = await vipOrderAdd(reqData)
        if (resData.code === RESPONSE_SUCCESS) {
          this.getOrderId = resData.data.id
          this.$message({
            message: this.$lang('下单成功！'),
            type: 'success'
          })
          if (this.printOrder) {
            const userInfo = this.userInfo
            const value = userInfo.surfaceFormat === 2 ? 'oneLinkPage' : 'twoLinkPage'
            this.$refs.print.toPrint(value)
            this.keyBtn1 = false
          } else {
            this.keyBtn = false
          }

          // this.formData = commonFun.deepClone(this.defaultFormData)
          this.$refs.sizeForm.resetFields()
          this.checkSenderFlag = false
          this.checkReceiverFlag = false
          // 寄件人默认信息
          this.getDefaultAddress({ type: 1 })
          // 收件人默认信息
          this.getDefaultAddress({ type: 2 })
          this.$router.push({ path: 'redirect/singleOrder' })
          this.areaList = []
          this.areaList2 = []
        } else if (resData.code === 149010023) {
          this.$message.warning(resData.msg)
          this.formData.senderProvinceId = ''// 收件省份id,
          this.formData.senderProvinceName = ''// 收件省份名称,
          this.formData.senderCityId = ''// 收件城市id,
          this.formData.senderCityName = ''// 收件城市名称,
          this.formData.senderAreaId = '' // 收件区域id,
          this.formData.senderAreaName = '' // 收件区域名称,
          this.formData.senderProvince = '' // 收件区省/市/区
          this.formData.senderProvince = ''
          this.keyBtn = false
        } else if (resData.code === 149010024) {
          this.$message.warning(resData.msg)
          this.formData.receiverProvinceId = ''// 收件省份id,
          this.formData.receiverProvinceName = ''// 收件省份名称,
          this.formData.receiverCityId = ''// 收件城市id,
          this.formData.receiverCityName = ''// 收件城市名称,
          this.formData.receiverAreaId = '' // 收件区域id,
          this.formData.receiverAreaName = '' // 收件区域名称,
          this.formData.receiverProvince = '' // 收件区省/市/区
          this.keyBtn = false
        } else {
          this.$message.error(resData.msg)
          this.keyBtn = false
        }
      } catch (error) {
        this.keyBtn1 = false
        this.keyBtn = false
      }
    },
    // 运费计算
    async getComCost(number, startAddressId, endAddressId, paymentModeId) {
      console.log('🚀 ~ getComCost ~ paymentModeId:', paymentModeId)
      let smModeType = 2
      if (paymentModeId) {
        switch (paymentModeId) {
          case 6:
            smModeType = 1
            break
          case 7:
            smModeType = 2
            break
          case 8:
            smModeType = 3
            break
        }
      }
      const { expressTypeCode, goodsTypeCode, senderCityId, receiverCityId } = this.formData
      const params = {
        value: number,
        startAddressId,
        endAddressId,
        smMode: smModeType,
        productTypeCode: expressTypeCode,
        goodsTypeCode,
        startCityId: senderCityId,
        endCityId: receiverCityId
      }
      const { data = 0 } = await getComCost(params)
      return data || 0
    },
    // 保价费计算
    async getComputationCost(param) {
      // 参数
      const params = {
        // 物品价值
        value: param.declaredValue,
        // 物品类型code
        goodsTypeCode: param.goods.code
      }
      // 调用接口
      const { data } = await getComputationCost(params)
      return data || 0
    },
    // 通过省市区匹配结算目的地(目的区域)
    async getSettlement(providerId, cityId, areaId, packageTotalWeight, type) {
      const reqData = { providerId, cityId, areaId }
      const { code, data } = await getSettlement(reqData)
      if (code === RESPONSE_SUCCESS && data) {
        const id = data.id
        return id
      } else {
        return ''
      }
    },
    // 城市重新赋值
    handleProvice(postalCode, type, areaName, isShow) {
      this.getAreaListData(postalCode, type, areaName, isShow)
      console.log('城市重新', this.formData)
    },
    // 收件人姓名模糊搜索
    async remoteReceiverName(queryString, cb) {
      this.loading = true
      const param = {
        current: 1,
        size: 100,
        type: 2,
        keyword: queryString
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString
          ? diseaseList.filter(this.createFilter(queryString, 'name'))
          : diseaseList
          // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(msg)
        this.loading = false
      }
    },
    // 收件人联系电话模糊搜索
    async remoteReceiverMobilePhone(queryString, cb) {
      this.loading = true
      const param = {
        current: 1,
        size: 100,
        type: 2,
        keyword: queryString
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString
          ? diseaseList.filter(this.createFilter(queryString, 'mobile'))
          : diseaseList
          // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(this.$lang(msg))
        this.loading = false
      }
    },
    // 寄件人姓名模糊搜索
    async remoteSenderName(queryString, cb) {
      this.loading = true
      const param = {
        current: 1,
        size: 100,
        type: 1,
        keyword: queryString
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString
          ? diseaseList.filter(this.createFilter(queryString, 'name'))
          : diseaseList
          // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(this.$lang(msg))
        this.loading = false
      }
    },
    // 寄件人联系电话模糊搜索
    async remoteSenderMobilePhone(queryString, cb) {
      this.loading = true
      const param = {
        current: 1,
        size: 100,
        type: 1,
        keyword: queryString
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString
          ? diseaseList.filter(this.createFilter(queryString, 'mobile'))
          : diseaseList
          // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(this.$lang(msg))
        this.loading = false
      }
    },

    createFilter(queryString, type) {
      return disease => {
        return (
          disease[type].toLowerCase().indexOf(queryString.toLowerCase()) !== -1 // 改为===0 就是筛选的数据只是首字匹配的列表项，需要包含输入字的所有列表项改为！==-1
        )
      }
    },

    /**
     * @description 获取回单金额
     */
    async getReceiptFee() {
      const params = {
        customerCode: this.userInfo.customerCode
      }
      const { data, msg, code } = await getReceiptFee(params)
      if (code === RESPONSE_SUCCESS) {
        this.receiptFreight = data
        this.formData.receiptFreight = this.receiptFreight
      } else {
        this.$message.error(this.$lang(msg))
      }
    }
  }

}
</script>
<style lang="scss" scoped>
.bc-bottom {
  margin: 20px 0;
  text-align: center;
  .enter_btn {
    height: 48px;
    ::v-deep {
      span{
        font-size: 18px;
      }
    }
  }
}
.singleOrder{
    padding: 0 24px;
    h3 {
        font-size: 20px
    }
    .width100{
        width: 100%;
    }
     .w360 {
         width: 100%;
         .el-input{
            width: 360px !important;
         }
     }

}

.group-title{
  border-bottom: 1px dashed #EEEEEE;
  // margin-bottom: 20px;
  margin: 0 10px 20px 10px;
  padding: 16px 0px;
  .title{
    font-size: 14px;
    color: #333;
    font-weight: 600;
    display: inline-block;
    line-height: 7px;
    border-bottom: 4px solid #E0BD7B;
  }
  .insert-info{
    display: inline-block;
    margin-left: 60px;
    position: relative;
    .icon{
      color: #E0BD7B;
      position: absolute;
      overflow: visible;
    }
    .text{
      color: #666666;
      margin-left: 20px;
    }
  }
}
.group-content{
    background: #f7f7f9;
    padding: 20px 20px 0px;
    border-radius: 8px;
  .el-textarea__inner{
    min-height: 60px;
  }
  .oper{
    position: absolute;
    right: 20px;
    bottom: 5px;
    cursor: pointer;
    color: #333;
    .red{
      color: red;
      margin-right: 20px;
    }
  }
}
.el-form.el-form-edit .el-form-item.insured-info .el-form-item__content{
  position: relative;
  .btn_insured_myself{
    color: #e60012;;
    font-size: 12px;
    cursor: pointer;
    display: inline-block;
    height: 22px;
    line-height: 16px;
    &:hover{
      text-decoration: underline;
    }
  }
}
</style>
<style lang="scss">

.el-form-item.declaredValue {
  .el-input-number .el-input__inner{
    text-align: left;
  }
}
.singleOrder{
    .el-form-item {
      .el-form-item__label{
        width: 180px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .area-code {
      width: 120px !important;
      .el-button {
        text-align: left;
      }
    }
}
</style>
